import { autocompleteClasses } from '@mui/material/Autocomplete';
import { filledInputClasses } from '@mui/material/FilledInput';
import { menuItemClasses } from '@mui/material/MenuItem';
import { alpha } from '@mui/system';
import { ArrowDownThin, Clear } from '@ori-ui/icons';
import { colors, textInputData } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
const styleOverrides = {
  inputRoot: {
    [`&[class*="${filledInputClasses.root}"]`]: {
      paddingTop: 0,
      paddingLeft: 10,
      '& input': {
        padding: '12.5px 0'
      }
    }
  },
  paper: {
    border: `1px solid ${colors.oriGrey[300]}`,
    borderRadius: 5,
    marginTop: 5,
    marginBottom: 5,
    boxShadow: 'none',
    transition: 'none'
  },
  option: {
    fontSize: textInputData.input.size,
    [`&.${autocompleteClasses.option}.${autocompleteClasses.focused}`]: {
      backgroundColor: 'unset'
    },
    [`&.${autocompleteClasses.option}.${menuItemClasses.focusVisible}`]: {
      backgroundColor: alpha(colors.primary.main, 0.08)
    },
    [`&.${autocompleteClasses.option}.${autocompleteClasses.focused}:hover`]: {
      backgroundColor: alpha(colors.primary.main, 0.08)
    },
    [`&.${autocompleteClasses.option}[aria-selected="true"]`]: {
      backgroundColor: alpha(colors.primary.main, 0.15)
    },
    [`&.${autocompleteClasses.option}[aria-selected="true"].${autocompleteClasses.focused}`]: {
      backgroundColor: alpha(colors.primary.main, 0.15)
    },
    [`&.${autocompleteClasses.option}[aria-selected="true"]:hover`]: {
      backgroundColor: alpha(colors.primary.main, 0.2)
    }
  }
};
const defaultProps = {
  clearIcon: /*#__PURE__*/_jsx(Clear, {
    fontSize: "small"
  }),
  popupIcon: /*#__PURE__*/_jsx(ArrowDownThin, {
    fontSize: "medium"
  })
};
export default {
  defaultProps,
  styleOverrides
};
//# sourceMappingURL=MuiAutocomplete.js.map